import React from 'react';
import { ACHTransferCompletePage } from 'src/Components/Accounts/ACHTransferCompletePage';
import PageContentContainer from 'src/Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import PageContentTop from 'src/Components/ComponentLibrary/Molecules/Page/PageContentTop';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';


const ScheduledCashJournalCompleteContent = () => {
  const { pageContentResource: resource } = usePageContentContext();

  const sourceAccount = {
    accountName: resource.attr?.('sourceAccountName'),
    maskedAccountNumber: resource.attr?.('sourceMaskedAccountNumber'),
    image: resource.attr?.('image'),
  };

  const transferInfo = {
    amount: resource.attr?.('amount'),
    startDate: resource.attr?.('startDate'),
    status: resource.attr?.('status'),
  };

  return (
    <PageContentContainer>
      <PageContentTop title={resource.attr?.('header')} />
      <ACHTransferCompletePage
        title={resource.attr?.('title')}
        subtitle={resource.attr?.('subtitle')}
        sourceAccount={sourceAccount}
        transferInfo={transferInfo}
      />
    </PageContentContainer>
  );
};

export { ScheduledCashJournalCompleteContent };
